// extracted by mini-css-extract-plugin
export default {"container":"Sp-z","heading":"Tp-z","text":"Up-z","info":"Vp-z","link":"Wp-z","fullMaxWidth":"Xp-z"};